<template>
	<div class="col-md-6 pb-3">
		<div class="card h-100 pl-3 pr-3">
			<div class="d-inline pt-1 my-auto">
				<!-- Financials Dropdown start -->
				<div class="d-inline-block">
					<div
						id="financials"
						class="dropdown_lp">
						<ul class="financials_dropdown list-unstyled my-auto">
							<li class="nav-item dropdown">
								<a
									class="nav-link dropdown-toggle"
									href="#"
									id="financials_dropdown_sub"
									data-toggle="dropdown"
									aria-haspopup="true"
									aria-expanded="false">
									<span class="d-inline-block pr-2">Financials</span>
									<i
										class="fas fa-chevron-right mx-2"
										aria-hidden="true"></i>
								</a>
								<ul
									class="dropdown-menu"
									aria-labelledby="financials_dropdown_sub">
									<!-- Bill run start -->
									<li class="dropdown-submenu">
										<a
											class="dropdown-item dropdown-toggle"
											href="#"
											>Bill Run<i class="fas fa-chevron-right"></i
										></a>
										<ul class="dropdown-menu">
											<router-link :to="{ name: 'billRun' }">
												<li><a class="dropdown-item">List</a></li>
											</router-link>
											<li class="dropdown-divider"></li>
											<li>
												<a
													class="dropdown-item dropdown-toggle"
													href="#"
													data-toggle="modal"
													data-target="#commitDraftBills"
													>Commit Drafts</a
												>
											</li>
											<li class="dropdown-divider"></li>
											<router-link :to="{ name: 'statementsOH' }">
												<li><a class="dropdown-item">Statements On Hold</a></li>
											</router-link>
										</ul>
									</li>
									<li class="dropdown-divider"></li>
									<!-- Bill run end -->
									<!-- Payments start -->
									<li class="dropdown-submenu" v-if="useNativeDD">
										<a
											class="dropdown-item dropdown-toggle"
											href="#"
											>Payments<i class="fas fa-chevron-right"></i
										></a>
										<ul class="dropdown-menu">
											<router-link :to="{ name: 'paymentRun' }">
												<li><a class="dropdown-item">Payment Generation</a></li>
											</router-link>
											<li class="dropdown-divider"></li>
											<router-link :to="{ name: 'collectionRun' }">
												<li><a class="dropdown-item">Collection Runs</a></li>
											</router-link>
											<li class="dropdown-divider"></li>
											<li>
												<a
													class="dropdown-item dropdown-toggle"
													href="#"
													data-toggle="modal"
													data-target="#lodgementRun"
													>Lodgement Run</a
												>
											</li>
										</ul>
									</li>
									<li class="dropdown-divider" v-if="useNativeDD"></li>
									<!-- Payments end -->
									<!-- DD Failures start -->
									<li class="dropdown-submenu" v-if="useNativeDD && showDdHandling">
										<a
											class="dropdown-item dropdown-toggle"
											href="#"
											>DD Failures<i class="fas fa-chevron-right"></i
										></a>
										<ul class="dropdown-menu">
											<router-link :to="{ name: 'ddFailureCharges' }">
												<li><a class="dropdown-item">Charge Management</a></li>
											</router-link>
											<router-link :to="{ name: 'aruddProcessingLogs' }">
												<li><a class="dropdown-item">ARUDD Processing Logs</a></li>
											</router-link>
										</ul>
									</li>
									<li class="dropdown-divider" v-if="useNativeDD && showDdHandling"></li>
									<!-- DD Failures end -->
									<!-- Reports start -->
									<li class="dropdown-submenu">
										<a
											class="dropdown-item dropdown-toggle"
											href="#"
											>Reports<i class="fas fa-chevron-right"></i
										></a>
										<ul class="dropdown-menu">
											<li>
												<a
													@click="generateReport()"
													class="dropdown-item"
													>Aged Debt</a
												>
											</li>
										</ul>
									</li>
									<!-- Reports end -->
								</ul>
							</li>
						</ul>
					</div>
				</div>
				<!-- Financials Dropdown end -->

				<!-- Service bundle start -->
				<div class="d-inline-block">
					<div
						id="service_bundle"
						class="dropdown_lp">
						<ul class="service_bundle_dropdown list-unstyled my-auto">
							<li class="nav-item dropdown">
								<a
									class="nav-link dropdown-toggle"
									href="#"
									id="service_bundle_dropdown_sub"
									data-toggle="dropdown"
									aria-haspopup="true"
									aria-expanded="false">
									<span class="d-inline-block pr-2">Service Bundle</span>
									<i
										class="fas fa-chevron-right mx-2"
										aria-hidden="true"></i>
								</a>
								<ul
									class="dropdown-menu"
									aria-labelledby="service_bundle_dropdown_sub">
									<li
										v-if="!TMSenabled"
										class="dropdown-submenu">
										<a
											class="dropdown-item dropdown-toggle"
											href="#"
											data-toggle="modal"
											data-target="#Import"
											>Import Service Bundle</a
										>
									</li>
									<li
										v-if="!TMSenabled"
										class="dropdown-divider"></li>
									<li
										v-if="!TMSenabled"
										class="dropdown-submenu">
										<a
											class="dropdown-item dropdown-toggle"
											href="#"
											data-toggle="modal"
											data-target="#ExportServiceBundle"
											>Export Service Bundle</a
										>
									</li>
									<li
										v-if="!TMSenabled"
										class="dropdown-divider"></li>
									<li class="dropdown-submenu">
										<a
											class="dropdown-item dropdown-toggle"
											href="#"
											data-toggle="modal"
											data-target="#BulkServiceBundleChange"
											@click="getLogs"
											>Service Bundle Change</a
										>
									</li>
								</ul>
							</li>
						</ul>
					</div>
				</div>
				<!-- Service bundle end -->

				<!-- Customer Dropdown 2 start -->
				<div class="d-inline-block" v-if="showSignUpLogs">
					<div
						id="customer_sign_ups"
						class="dropdown_lp">
						<ul class="customer_sign_ups_dropdown list-unstyled my-auto">
							<li class="nav-item dropdown">
								<a
									class="nav-link dropdown-toggle"
									href="#"
									id="customer_sign_ups_dropdown_sub"
									data-toggle="dropdown"
									aria-haspopup="true"
									aria-expanded="false">
									<span class="d-inline-block pr-2">Customer</span>
									<i
										class="fas fa-chevron-right mx-2"
										aria-hidden="true"></i>
								</a>
								<ul
									class="dropdown-menu"
									aria-labelledby="customer_sign_ups_dropdown_sub">
									<router-link :to="{ name: 'signUpLogs' }">
										<li class="dropdown-submenu">
											<a
												class="dropdown-item dropdown-toggle"
												href="#"
												>Sign Up Logs</a
											>
										</li>
									</router-link>
								</ul>
							</li>
						</ul>
					</div>
				</div>
				<!-- Customer Dropdown 2 end -->
				<!-- Other start -->
				<div class="d-inline-block">
					<div
						id="other_functionality"
						class="dropdown_lp">
						<ul class="other_functionality_dropdown list-unstyled my-auto">
							<li class="nav-item dropdown">
								<a
									@click="backgroundLogin"
									class="nav-link dropdown-toggle"
									href="#"
									id="other_functionality_dropdown_sub"
									data-toggle="dropdown"
									aria-haspopup="true"
									aria-expanded="false">
									<span class="d-inline-block pr-2">Other</span>
									<i
										class="fas fa-chevron-right mx-2"
										aria-hidden="true"></i>
								</a>
								<ul
									class="dropdown-menu"
									aria-labelledby="other_functionality_dropdown_sub">
									<li class="dropdown-submenu">
										<a
											class="dropdown-item dropdown-toggle"
											href="#"
											data-toggle="modal"
											data-target="#ViewSscInfo"
											@click="resetSsc"
											>SSC Search</a
										>
									</li>
									<li class="dropdown-submenu">
										<a
											class="dropdown-item dropdown-toggle"
											href="#"
											@click="$router.push('/erroneous-transfers')"
											>Erroneous Transfers</a
										>
									</li>
									<li
										class="dropdown-item dropdown-toggle"
										href="#"
										@click="$router.push('/on-hold-rules')">
										On Hold Rules
									</li>
								</ul>
							</li>
						</ul>
					</div>
				</div>
				<!-- Other end -->
			</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue';

export default {
	computed: {
		accessToken() {
			return this.$auth.accessToken;
		},
		xsrfToken() {
			return this.$auth.xsrfToken;
		},
		moneybot() {
			return Vue.config.honeycomb.moneybot.domain;
		},
		brackets() {
			return Vue.config.honeycomb.agedDebt.brackets.join(',');
		},
		TMSenabled() {
			return Vue.config.honeycomb.tariffmanagementservice.enabled;
		},
		showSignUpLogs() {
			return Vue.config.honeycomb.showSignUpLogs;
		},
		showDdHandling() {
			return Vue.config.honeycomb.ddbot.showDdHandling
		},
		useNativeDD() {
			return Vue.config.honeycomb.useNativeDD;
		},
	},
	methods: {
		resetSsc() {
			this.$store.commit('updateSscInfo', null);
		},
		backgroundLogin() {
			this.$auth.backgroundLogin();
		},
		getLogs() {
			this.$store.dispatch('getServiceBundleLogs');
		},
		async generateReport() {
			// let resp = await this.$auth.backgroundLogin()
			// this.$snotify.success(`Generating aged debt report...`)
			window.open(
				'https://' +
					this.moneybot +
					'/api/v1/reports/ageddebt/export?brackets=' +
					this.brackets +
					'&token=' +
					this.accessToken +
					'&xsrf=' +
					this.xsrfToken,
				'_self'
			);
		},
	},
};
</script>
